import React from "react";

import { FormattedMessage } from "react-intl";

import { Text } from "@/components/atoms/Text";

import { BookingStepsItem } from "./BookingStepsItem";
import { useBookingStepsSectionList } from "./useBookingStepsSectionList";

const BookingStepsSection = () => {
  const items = useBookingStepsSectionList();

  return (
    <section className="tw-bg-gray-900 tw-w-full tw-py-40 lg:tw-py-96">
      <div className="ps-container-lg-margin ps-container-fixed">
        <div className="ps-row">
          <div className="col-xs-12 tw-flex tw-flex-col">
            {/* Copy */}
            <div className="tw-flex tw-flex-col tw-gap-24 lg:tw-gap-12">
              <div className="tw-flex tw-flex-col">
                <Text
                  element="p"
                  typeface="headline-3-b"
                  className="lg:tw-headline-4-b tw-text-brand-purple tw-mb-24 lg:tw-mb-8"
                >
                  <FormattedMessage defaultMessage="How it works" />
                </Text>
                <Text
                  element="h2"
                  typeface="headline-6-b"
                  className="lg:tw-display-1-b tw-text-brand-white"
                >
                  <FormattedMessage defaultMessage="3 steps to your first booking" />
                </Text>
              </div>
              <div>
                <Text
                  element="p"
                  typeface="body-3"
                  className="lg:tw-body-4 tw-text-brand-white tw-inline lg:tw-block"
                >
                  <FormattedMessage defaultMessage="Getting started is free and takes about 15 minutes." />
                  &nbsp;
                </Text>
                <Text
                  element="p"
                  typeface="body-3"
                  className="lg:tw-body-4 tw-text-brand-white tw-inline lg:tw-block"
                >
                  <FormattedMessage defaultMessage="Most hosts receive their first inquiry within a week." />
                </Text>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Steps */}
      <div className="tw-relative tw-mt-32 lg:tw-mt-96">
        {/* Desktop horizontal connecting line (spans center-to-center of first and last circles) */}
        <div className="ps-container-lg-margin ps-container-fixed">
          <div className="ps-row">
            <div className="col-xs-12 tw-flex tw-flex-col tw-relative">
              <div
                className="tw-absolute tw-left-0 tw-hidden lg:tw-block tw-h-2 tw-bg-brand-white tw-top-36 tw-w-full"
                aria-hidden="true"
              />
            </div>
          </div>
        </div>
        <div className="ps-container-md-margin ps-container-fixed">
          <div className="ps-row">
            <div className="col-xs-12 tw-flex tw-flex-col">
              <div className="tw-w-full tw-flex tw-flex-col lg:tw-flex-row tw-items-center lg:tw-items-start tw-gap-16 lg:tw-gap-[64px]">
                <div
                  className="lg:tw-hidden tw-w-2 tw-h-32 tw-bg-brand-white"
                  aria-hidden="true"
                />
                {items.map(
                  (
                    {
                      bookingStepTitle,
                      bookingStepNumber,
                      bookingStepDescription,
                    },
                    index,
                  ) => (
                    <BookingStepsItem
                      key={bookingStepNumber}
                      stepNumber={bookingStepNumber}
                      title={bookingStepTitle}
                      description={bookingStepDescription}
                      visuallyConnectWithPrevStep={index > 0}
                    />
                  ),
                )}
                <div
                  className="lg:tw-hidden tw-w-2 tw-h-32 tw-bg-brand-white"
                  aria-hidden="true"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export { BookingStepsSection };
